/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_BenchInputs */

const en_platform_plan_bench = /** @type {(inputs: Platform_Plan_BenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bench press`)
};

const pl_platform_plan_bench = /** @type {(inputs: Platform_Plan_BenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyciskanie leżąc`)
};

/**
* | output |
* | --- |
* | "Bench press" |
*
* @param {Platform_Plan_BenchInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_bench = /** @type {((inputs?: Platform_Plan_BenchInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_BenchInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_bench(inputs)
	return en_platform_plan_bench(inputs)
});